import { bookingUrl } from "../../consts/acco"
import { IBookingHotel } from "../../shared-interfaces/booking-hotel"

export const getReferrerDomain = () => {
  if (typeof document !== "undefined") {
    const url = document.createElement("a")
    url.href = document.referrer
    return url.hostname
  }
  return "ssr"
}

export const createBookingLink = (hotel_url: string, tourSlug: string) => `${bookingUrl}${hotel_url}?aid=818140&label=${tourSlug}-${getReferrerDomain()}`
export const createBookingLinkParams = (acco: IBookingHotel, tourSlug: string) => ({
  ...acco,
  tourSlug,
  referrerDomain: getReferrerDomain(),
})
